import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const OrderSuccess = ({ orderId, selectedPayment }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  
  // Add a slight delay before showing component to ensure stable rendering
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  if (!isVisible) {
    return <div className="max-w-lg mx-auto my-16 p-8 flex justify-center">
      <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
    </div>;
  }
  
  return (
    <div className="max-w-lg mx-auto my-16 p-8 bg-white rounded-lg shadow-lg text-center">
      <div className="w-20 h-20 rounded-full bg-green-100 text-green-600 text-4xl flex items-center justify-center mx-auto mb-6">
        ✓
      </div>
      <h2 className="text-2xl font-bold mb-4">Благодарим Ви за поръчката!</h2>
      <p className="mb-2 text-gray-700">Вашата поръчка #{orderId} е приета успешно.</p>
      {selectedPayment === 'bacs' ? (
        <>
          <p className="mb-2 text-gray-700">Вашата поръчка е в изчакване на потвърждение за плащане.</p>
          <p className="mb-6 text-gray-700">Моля, завършете банковия превод, използвайки предоставените детайли.</p>
        </>
      ) : (
        <p className="mb-6 text-gray-700">Ще получите имейл с потвърждение скоро.</p>
      )}
      <button 
        className="px-6 py-3 bg-primary text-white font-medium rounded-md hover:bg-primary/80 transition"
        onClick={() => navigate('/')}
      >
        Продължи с пазаруването
      </button>
    </div>
  );
};

export default OrderSuccess; 